import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Fieldset, Legend, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input,
    Collapse
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect, withRouter } from "react-router-dom"
import apiResponse from '../../../../../services/apiResponse'

import { cancelToken } from '../../../../../services/adapters/kepegawaian/kenaikanpangkatService'
import IndexBloc from '../Blocs/IndexBloc'

class SKModal extends Component {

    indexBloc = new IndexBloc()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            dataForm: null,
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                promotion_uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.indexBloc.fetchInputSK(this.state.dataForm)
        // if (this.props.uuid === '') {
        //     await this.createBloc.fetchCreate(this.state.dataForm)
        // } else {
        //     await this.createBloc.fetchCreateDetail(this.state.dataForm)
        // }
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.inputSKChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    //this.props.setUuid(result.data.response.employee_transfer_uuid)
                    //this.createBloc.fetchCreateDetail({ ...this.state.dataForm, uuid: result.data.response.employee_transfer_uuid })
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.props.toggle()
                    this.props.handleReload()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    this.props.toggle()
                    break
                default:
                    break;
            }
        })
    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.modal} size='lg' toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle}>Input SK</ModalHeader>
                    <ModalBody>
                        <AvForm
                            className="needs-validation"
                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                        >
                            <Row className="mb-3">
                                <label
                                    htmlFor="no_sk"
                                    className="col-md-3 col-form-label"
                                >
                                Nomor SK <span className="text-danger">*</span>
                                </label>
                                <Col md="4">
                                    <AvField
                                        name="promotion_decree_number"
                                        id="promotion_decree_number"
                                        placeholder="Nomor SK"
                                        type="text"
                                        errorMessage="Masukan Nomor SK"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        // value={this.state.detail?.promotion_decree_number}
                                    />
                                </Col>
                            </Row>  

                            <Row className="mb-3">
                                <label
                                    htmlFor="no_sk"
                                    className="col-md-3 col-form-label"
                                >
                                Tanggal SK <span className="text-danger">*</span>
                                </label>
                                <Col md="3">
                                    <AvField
                                        name="promotion_decree_date"
                                        id="promotion_decree_date"
                                        placeholder="Tanggal SK"
                                        type="date"
                                        errorMessage="Masukan Tanggal SK"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        // value={this.state.detail?.promotion_decree_date}
                                    />
                                </Col>
                            </Row>    

                            <Row className="mb-3">
                                <label
                                    htmlFor="no_sk"
                                    className="col-md-3 col-form-label"
                                >
                                TMT SK <span className="text-danger">*</span>
                                </label>
                                <Col md="3">
                                    <AvField
                                        name="promotion_tmt_date"
                                        id="promotion_tmt_date"
                                        placeholder="TMT SK"
                                        type="date"
                                        errorMessage="Masukan TMT SK"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        // value={this.state.detail?.promotion_tmt_date}
                                    />
                                </Col>
                            </Row>       
                        
                            <ModalFooter>
                                <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>{' '}
                                <Button color="primary" type="submit">Submit</Button>
                            </ModalFooter>
                        </AvForm>
                    </ModalBody>
                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />

            </Fragment>
        )
    }
}

export default withRouter(SKModal)